import type { FunctionComponent } from 'react'
import { Platform } from 'react-native'
import { Icon as IconWeb } from './icon.web'
import { Icon as IconNative, IconProps as NativeIconProps } from './icon'

export type { SVGName } from './icon'

export const Icon: typeof IconNative = Platform.select<() => typeof IconNative>({
  android: (): FunctionComponent<NativeIconProps> => IconNative,
  ios: (): FunctionComponent<NativeIconProps> => IconNative,
  // @ts-ignore
  web: () => IconWeb,
  default: (): FunctionComponent<NativeIconProps> => () => null,
})()
